"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateJobOffersContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const job_offers_request_1 = require("./job-offers.request");
const job_offers_response_1 = require("./job-offers.response");
const c = (0, core_1.initContract)();
exports.CandidateJobOffersContract = c.router({
    findById: {
        method: 'GET',
        path: '/:offerId',
        responses: { 200: job_offers_response_1.JobOfferDetailResponseSchema },
        pathParams: job_offers_request_1.JobOfferIdPathParamsSchema,
    },
    findMany: {
        method: 'GET',
        path: '/',
        query: job_offers_request_1.JobOfferListQuerySchema,
        responses: { 200: job_offers_response_1.JobOfferListItemResponseSchema },
    },
    updateStatus: {
        method: 'POST',
        path: '/:offerId',
        body: job_offers_request_1.JobOfferUpdateStatusRequestSchema,
        responses: { 200: schemas_1.BaseResponseSchema },
        pathParams: job_offers_request_1.JobOfferIdPathParamsSchema,
    },
}, { pathPrefix: '/offers' });
